import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useStore as useVuexStore } from 'vuex';


export const useUserStore = defineStore('user', () => {
    const user = ref(null);
    const vuexStore = useVuexStore();
    user.value = vuexStore.state.userSession.user;
    const usuarioId = ref(user.value.idU);
    const nomeUsuario = ref(user.value.user_metadata.full_name);
    const email = ref(user.value.email);
    const avatar = ref(user.value.user_metadata.avatar_url);
    const funcao = ref(user.value.funcao);
    const disciplinaId = ref(user.value.disciplina);
    const disciplinaNome = ref(user.value.disciplinaNome);
    const areaId = ref(user.value.areaId);
    const areaNome = ref(user.value.areaNome);

    return { usuarioId, email, avatar, funcao, disciplinaId, disciplinaNome, areaId, areaNome };

});